module.exports = __webpack_public_path__ + "intuit-mockup@2x.2qbEIrgI.png";